var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0404 56.875V51.4583C46.0404 48.5852 44.899 45.8297 42.8674 43.798C40.8357 41.7664 38.0802 40.625 35.207 40.625H13.5404C10.6672 40.625 7.91169 41.7664 5.88004 43.798C3.8484 45.8297 2.70703 48.5852 2.70703 51.4583V56.875M62.2904 56.875V51.4583C62.2886 49.058 61.4897 46.7263 60.0191 44.8292C58.5485 42.9321 56.4895 41.5772 54.1654 40.9771M43.332 8.47708C45.6623 9.07373 47.7278 10.429 49.2027 12.3292C50.6777 14.2294 51.4783 16.5664 51.4783 18.9719C51.4783 21.3773 50.6777 23.7144 49.2027 25.6146C47.7278 27.5148 45.6623 28.87 43.332 29.4667M35.207 18.9583C35.207 24.9414 30.3568 29.7917 24.3737 29.7917C18.3906 29.7917 13.5404 24.9414 13.5404 18.9583C13.5404 12.9752 18.3906 8.125 24.3737 8.125C30.3568 8.125 35.207 12.9752 35.207 18.9583Z",
    stroke: "#F5F5F5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersBg);
export default __webpack_public_path__ + "static/media/UsersBG.532c22aaff0ec8a9be4aafad8d00faf2.svg";
export { ForwardRef as ReactComponent };